module.exports = __webpack_public_path__ + "img/card-training.2e3f6f0d.jpg";